import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CotizacionesRoutingModule } from "./cotizaciones-routing.module";
import { CotizacionesComponent } from "./cotizaciones.component";
import { NgxPermissionsModule } from "ngx-permissions";
import { BotonToggleModule } from "../../../components/boton/boton-toggle.module";
import { CotizacionModule } from "../../../forms/cotizaciones/cotizacion.module";
import { TipoPagoModule } from "../../../forms/cotizaciones/tipos-pago/tipo-pago.module";
import { TipoImpuestoModule } from "../../../forms/cotizaciones/tipos-impuesto/tipo-impuesto.module";
import { TipoValidezModule } from "../../../forms/cotizaciones/tipos-validez/tipo-validez.module";
import { TipoMonedaModule } from "../../../forms/cotizaciones/tipos-moneda/tipo-moneda.module";
import { TipoPlazoModule } from "../../../forms/cotizaciones/tipos-plazo/tipo-plazo.module";
import { TipoGarantiaModule } from "../../../forms/cotizaciones/tipos-garantia/tipo-garantia.module";
import { TipoEntregaModule } from "../../../forms/cotizaciones/tipos-entrega/tipo-entrega.module";
import { TipoCondicionModule } from "../../../forms/cotizaciones/tipos-condicion/tipo-condicion.module";
import { CompetidorModule } from "../../../forms/cotizaciones/competidores/competidor.module";
import { MaterialModule } from "../../../components/material/material.module";
import { CaracteristicaService } from "../../../providers/caracteristica.service";
import { ProductoService } from "../../../providers/producto.service";
import { TipoIncidenciaService } from "../../../providers/tipo-incidencia.service";
import { TipoProductoService } from "../../../providers/tipo-producto.service";
import { AccesorioService } from "../../../providers/accesorio.service";
import { TiposCondicionComponent } from "./tipos-condicion/tipos-condicion.component";
import { VolverModule } from "../../../components/volver/volver.module";
import { TiposPagoComponent } from "./tipos-pago/tipos-pago.component";
import { TiposMonedaComponent } from "./tipos-moneda/tipos-moneda.component";
import { TiposValidezComponent } from "./tipos-validez/tipos-validez.component";
import { TiposEntregaComponent } from "./tipos-entrega/tipos-entrega.component";
import { TiposImpuestoComponent } from "./tipos-impuesto/tipos-impuesto.component";
import { TiposGarantiaComponent } from "./tipos-garantia/tipos-garantia.component";
import { TiposPlazoComponent } from "./tipos-plazo/tipos-plazo.component";
import { CompetidoresComponent } from "./competidores/competidores.component";

@NgModule({
    imports: [
        CommonModule,
        CotizacionesRoutingModule,
        NgxPermissionsModule.forChild(),
        BotonToggleModule,
        CotizacionModule,
        TipoPagoModule,
        TipoImpuestoModule,
        TipoValidezModule,
        TipoMonedaModule,
        TipoPlazoModule,
        TipoGarantiaModule,
        TipoEntregaModule,
        TipoCondicionModule,
        CompetidorModule,
        MaterialModule,
        VolverModule,
    ],
    declarations: [
        CotizacionesComponent,
        TiposCondicionComponent,
        TiposPagoComponent,
        TiposMonedaComponent,
        TiposValidezComponent,
        TiposEntregaComponent,
        TiposImpuestoComponent,
        TiposGarantiaComponent,
        TiposPlazoComponent,
        CompetidoresComponent,
    ],
    providers: [
        AccesorioService,
        CaracteristicaService,
        ProductoService,
        TipoProductoService,
        TipoIncidenciaService,
    ]
})
export class CotizacionesModule { }